<script lang="ts">
  import { getContext } from 'svelte'
  import { twMerge } from 'tailwind-merge'
  type TitleType = {
    id?: string
    title?: string
  }
  type DescType = {
    id?: string
    desc?: string
  }

  interface BaseProps {
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
    role?: string
    color?: string
    withEvents?: boolean
    onclick?: (event: MouseEvent) => void
    onkeydown?: (event: KeyboardEvent) => void
    onkeyup?: (event: KeyboardEvent) => void
  }

  interface CtxType extends BaseProps {}
  interface Props extends BaseProps {
    title?: TitleType
    desc?: DescType
    ariaLabel?: string
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  }

  const ctx: CtxType = getContext('iconCtx') ?? {}
  const sizes = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
    xl: 'w-8 h-8'
  }

  export let size: Props['size'] = ctx.size || 'md'
  export let role: Props['role'] = ctx.role || 'img'
  export let color: Props['color'] = ctx.color || 'currentColor'
  //export let withEvents: Props['withEvents'] = ctx.withEvents || false
  export let title: TitleType = {}
  export let desc: DescType = {}

  let ariaDescribedby = `${title.id || ''} ${desc.id || ''}`
  let hasDescription = false

  $: if (title.id || desc.id) {
    hasDescription = true
  } else {
    hasDescription = false
  }
  export let ariaLabel = 'archive solid'
  export let strokeWidth = 2
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  fill={color}
  {...$$restProps}
  class={twMerge('shrink-0', sizes[size ?? 'md'], $$props.class)}
  {role}
  aria-label={ariaLabel}
  aria-describedby={hasDescription ? ariaDescribedby : undefined}
  viewBox="0 0 105.83 29.104"
>
  {#if title.id && title.title}
    <title id={title.id}>{title.title}</title>
  {/if}
  {#if desc.id && desc.desc}
    <desc id={desc.id}>{desc.desc}</desc>
  {/if}
  <linearGradient id="A" gradientUnits="userSpaceOnUse"
    ><stop offset="0" stop-color="#c53e00" /><stop
      offset="1"
      stop-color="#db8253"
    /></linearGradient
  ><linearGradient
    id="B"
    x1="84.003"
    x2="84.003"
    xlink:href="#A"
    y1="25.614"
    y2="6.407"
  /><linearGradient
    id="C"
    x1="99.479"
    x2="99.480"
    xlink:href="#A"
    y1="59.316"
    y2="62.627"
  /><linearGradient
    id="D"
    x1="35.84"
    x2="35.84"
    xlink:href="#A"
    y1="22.563"
    y2="7.55"
  /><linearGradient
    id="E"
    gradientUnits="userSpaceOnUse"
    x1="80.233"
    x2="80.233"
    y1="25.644"
    y2="12.47"
    ><stop offset="0" stop-color="#de6d00" /><stop
      offset="1"
      stop-color="#e0851e"
    /></linearGradient
  ><linearGradient
    id="F"
    gradientUnits="userSpaceOnUse"
    x1="41.95"
    x2="41.95"
    y1="22.493"
    y2="12.31"
    ><stop offset="0" stop-color="#eba91e" /><stop
      offset="1"
      stop-color="#ecb356"
    /></linearGradient
  ><filter
    id="G"
    color-interpolation-filters="sRGB"
    height="1.034"
    width="1.007"
    x="-.005"
    y="-.01"
    ><feFlood flood-color="#4b4b4b" flood-opacity=".5" /><feComposite
      in2="SourceGraphic"
      operator="in"
    /><feGaussianBlur stdDeviation=".2" /><feOffset
      dx="-.8"
      dy="1"
      result="A"
    /><feComposite in="SourceGraphic" result="B" /><feColorMatrix
      values="0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
    /><feFlood flood-color="#9b9b9b" flood-opacity=".5" /><feComposite
      in2="B"
      operator="in"
    /><feGaussianBlur stdDeviation=".2" /><feComposite in="B" in2="A" /></filter
  ><path
    d="M12.664 20.39A26.01 18.93 0 0 1 25.67 3.996a26.01 18.93 0 0 1 26.01 0 26.01 18.93 0 0 1 13 16.396"
    fill="#fff"
  /><text
    font-family="Arial"
    font-size="3.307"
    letter-spacing="-.344"
    text-anchor="middle"
    x="87"
    y="7"
    fill="#fff">ノーティルジョン</text
  ><path
    d="M38.45 2.46l-2.814.12.57 7.884a9.7 9.7 0 0 0-1.1.364L32.85 2.93l-2.866.64 4.08 7.75a10.73 10.73 0 0 0-1.09.7l-6-7.546-3.294 1.446 8.23 7.024-.56.62-10.965-5.594-3.3 2.864 13.06 4.635-.06.13-15.8-.773-1.44 4.41 16.477-.59-.02.6H48.05l-.02-.574 16.63.59-1.78-4.783-15.63 1.1a9.03 9.03 0 0 0-.79-1.393l12.57-4.57-3.47-2.615-10.71 5.406a9.8 9.8 0 0 0-1.25-.9l8-6.537-3.75-1.297-5.746 7.107a9.54 9.54 0 0 0-1.62-.46l4.055-7.38-3.164-.39-2.21 7.61a9.94 9.94 0 0 0-1.303.02z"
    fill="#d8653d"
  /><path
    d="M266.2 21.766c-3.154 0-5.787 2.633-5.787 5.787v5.17c0 1.72.78 3.28 2 4.35-1.21.417-2.03 1.553-2.04 2.834V69.37h-9.62V37.593c-.004-1.67-1.357-3.02-3.025-3.02h-15.156a3 3 0 0 0-.49.047 5.64 5.64 0 0 0 .26-1.7v-5.17c0-3.154-2.633-5.787-5.787-5.787h-9.24c-3.154 0-5.787 2.633-5.787 5.787v5.17c0 1.883.94 3.58 2.367 4.643a3.02 3.02 0 0 0-2.48 2.975v37.25L206.144 66c-.79-1.76-3-2.34-4.555-1.195-.743.55-4.63 1.92-7.346 1.75-1.357-.086-2.375-.465-2.924-.93s-.943-1.013-.943-2.68v-10.98h16.48c1.67 0 3.02-1.356 3.02-3.025V37.59c0-1.666-1.354-3.015-3.02-3.02h-16.48v-5.006c0-1.673-1.355-3.03-3.027-3.027h-15c-1.664 0-3.013 1.35-3.02 3.01l-.02 5.24a3.07 3.07 0 0 0-1.12-.22h-14.51c-1.666 0-3.016 1.35-3.02 3.02v30.08c0 .636-.13.8-.643 1.166s-1.48.68-2.473.69-1.94-.29-2.42-.635-.62-.49-.62-1.21v-30.09c0-1.67-1.36-3.02-3.027-3.02h-14.27a3.04 3.04 0 0 0-1.87.664 3.02 3.02 0 0 0-1.887-.666h-14.19a3.02 3.02 0 0 0-2.635 1.563 23.17 23.17 0 0 0-5.73-1.613c-8.51-1.247-17.33 2.3-22.877 9.773-1.52 2.05-2.723 4.277-3.607 6.604V28.786c0-1.67-1.355-3.027-3.027-3.025H54.636c-1.67 0-3.03 1.353-3.027 3.025v19.44L34.555 26.9c-.574-.72-1.44-1.136-2.36-1.137H14.323c-1.67 0-3.02 1.357-3.02 3.025v55.623c0 1.67 1.35 3.025 3.02 3.027h17.87c1.673 0 3.03-1.355 3.027-3.027V64.973l17.05 21.326a3.02 3.02 0 0 0 2.363 1.137h16.75c1.673 0 3.03-1.355 3.027-3.027V71.055a27.28 27.28 0 0 0 3.963 7.064c6.9 8.876 18.47 11.88 28.324 7.654.513 1.014 1.55 1.656 2.69 1.66h14.06c1.67-.004 3.02-1.357 3.02-3.025v-6.865c1.32 1.884 3.115 3.56 5.154 4.98a27.77 27.77 0 0 0 15.7 4.94c5.85 0 11.527-1.78 15.953-4.56 3.835-2.41 6.98-5.674 7.75-9.68 2.72 5.747 8.174 9.93 14.2 12.17 8.59 3.187 18.766 3.01 25.99-2.103a3.54 3.54 0 0 0 .207-.164v1.285c0 1.67 1.35 3.025 3.02 3.027h15.26a3.01 3.01 0 0 0 1.45-.375 3.01 3.01 0 0 0 1.42.375h17.56c-.254.3-.446.65-.566 1.025l-4.186 13.75c-.447 1.463.27 3.03 1.67 3.65 6.53 2.89 14.7 1.793 21.54-1.906s12.546-10.407 12.89-19.18a3 3 0 0 0 0-.117V73.293c10.334 18.856 37.37 18.996 47.9.25v10.654c0 1.67 1.355 3.027 3.027 3.025l14.934-.01c1.67 0 3.02-1.35 3.025-3.02V57.383c0-1.743.53-2.67 1.23-3.33s1.704-1.027 2.746-1.027 2.045.37 2.746 1.027 1.226 1.586 1.227 3.33v26.81c0 1.67 1.354 3.026 3.025 3.025h13.94c1.67 0 3.03-1.353 3.027-3.025v-35.25c0-5.234-4.01-10.1-9.84-13.09a20.19 20.19 0 0 0-10.195-2.17c-2.75.135-5.684 1.595-8.59 3.004-.25-1.17-1.167-2.087-2.34-2.33H332.41c-1.67 0-3.025 1.35-3.027 3.02v9.975c-4.67-8.313-13.636-13.947-23.88-13.947a27.39 27.39 0 0 0-24.02 14.195v-7.7c-.01-1.34-.903-2.52-2.193-2.887 1.186-1.066 1.94-2.606 1.94-4.295V27.55c0-3.154-2.633-5.787-5.787-5.787zm39.3 29.81c9.34 8.19 9.406 10.15 0 17.39-9.343-7.365-9.31-9.16 0-17.39zm-206.186.054c11.88 11.77 11.574 7.1 0 18.537-11.885-11.766-11.57-7.095 0-18.537zm206.19-.054a8.7 8.7 0 0 0-8.695 8.695 8.7 8.7 0 0 0 8.695 8.695c4.8 0 8.69-3.894 8.695-8.695a8.7 8.7 0 0 0-8.695-8.695zm-206.19.254c-5.08 0-9.176 4.06-9.176 9.07s4.1 9.065 9.176 9.065 9.176-4.054 9.176-9.065-4.1-9.07-9.176-9.07zm206.19 2.29c3.434 0 6.156 2.715 6.156 6.15a6.11 6.11 0 0 1-6.156 6.156c-3.434 0-6.15-2.72-6.15-6.156a6.1 6.1 0 0 1 6.15-6.15zm-206.19.627c3.505 0 6.275 2.757 6.275 6.18s-2.77 6.17-6.275 6.17-6.273-2.747-6.273-6.17 2.77-6.18 6.273-6.18z"
    fill="#fff"
    filter="url(#G)"
    transform="matrix(.2646 0 0 .2646 -.001008 .000902)"
  /><g stroke-width=".265"
    ><path
      d="M57.49 6.537a.722.722 0 0 0-.72.723v1.381a.72.72 0 0 0 .72.72h2.464a.72.72 0 0 0 .72-.72V7.257a.72.72 0 0 0-.72-.72zM8.523 7.613l-4.736.002V22.33h4.736v-7.402l5.93 7.405h4.434V7.617h-4.434v7.426zm37.043.213v9.354c0 2.274 1.66 3.903 3.694 4.666 2.214.771 4.584.657 6.163-.463l-1.62-3.606c-1.373.86-4.236 1.186-4.236-1.15v-3.673h5.16V9.95h-5.16V7.826zM25.847 9.86c-1.725-.016-3.42.805-4.56 2.34-1.736 2.34-1.7 5.68.08 7.974s4.832 2.9 7.253 1.43c.153-.095.29-.056.29.139v.59h3.754V9.947H28.91v.71c0 .12-.235.046-.406-.06a5.46 5.46 0 0 0-1.915-.68zm7.808.087v8.724c0 .91.66 1.82 1.64 2.51a6.58 6.58 0 0 0 3.683 1.16 7.25 7.25 0 0 0 3.773-1.08c1.033-.65 1.746-1.527 1.746-2.446V9.947h-3.835v7.921c0 .373-.185.787-.453.98a2.42 2.42 0 0 1-1.169.378 2.34 2.34 0 0 1-1.167-.362c-.282-.19-.46-.654-.447-.994V9.948zm27.879.003v12.385h7.4v-3.18h-3.39V9.95zm-4.794.7v11.61h4.036V10.65zm-30.407 2.816c1.485 0 2.693 1.194 2.693 2.664s-1.21 2.664-2.693 2.664S23.64 17.6 23.64 16.13s1.21-2.664 2.693-2.664z"
      fill="url(#F)"
      stroke="url(#D)"
    /><path
      d="M70.42 6.56a.72.72 0 0 0-.72.72v1.384a.72.72 0 0 0 .72.72h2.464a.72.72 0 0 0 .72-.72V7.28a.72.72 0 0 0-.72-.72zm10.41 3.075c-3.55 0-6.43 2.847-6.43 6.36s2.88 6.36 6.43 6.36 6.43-2.847 6.43-6.36-2.88-6.36-6.43-6.36zm14.21.105c-.883-.002-1.78.284-2.774.897h-.001c-.19.14-.356.15-.356.01v-.695H87.95V22.34h3.957v-7.08c0-1.06.64-1.965 1.88-1.965s1.82.907 1.82 1.965v7.08h3.69v-9.264c0-.965-.857-2.143-2.183-2.825-.71-.333-1.39-.51-2.076-.51zm-25.353.817v11.79c0 1.193-1.986 1.62-2.894 1.284l-1.1 3.607c1.46.76 3.61.305 4.925-.394 1.596-.88 3.054-2.48 3.054-4.494V10.557zm11.145 2.88a2.561 2.56 0 0 1 2.557 2.555 2.56 2.56 0 0 1-2.557 2.555c-1.41 0-2.555-1.145-2.555-2.555s1.145-2.555 2.555-2.555z"
      fill="url(#E)"
      stroke="url(#B)"
    /></g
  ><path
    d="M305.506 50.13c-5.567 0-10.295 4.761-10.295 10.33a10.47 10.47 0 0 0 10.295 10.303 10.47 10.47 0 0 0 10.295-10.303c0-5.575-4.724-10.332-10.295-10.332zm-206.004.252c-5.896 0-10.707 4.75-10.707 10.6s4.8 10.6 10.707 10.6 10.707-4.75 10.707-10.6-4.803-10.6-10.707-10.6zm206.004.977h.037c4.983-.006 9.035 4.055 9.07 9.107 0 5.027-4.064 9.1-9.11 9.1s-9.11-4.07-9.07-9.1c.04-5.014 4.04-9.087 9.07-9.107zm-206.004.082a9.6 9.6 0 0 1 9.652 9.547c0 5.27-4.31 9.54-9.65 9.54s-9.65-4.27-9.65-9.54 4.31-9.547 9.65-9.547z"
    fill="url(#C)"
    transform="matrix(.264582 0 0 .264582 -.001364 0)"
  /><path
    d="M57.495 6.668a.59.59 0 0 0-.6.6v.57a1.38 1.38 0 0 1 .7-.25l2.945-.002v-.32a.59.59 0 0 0-.6-.6zM3.919 7.75v.94h4.6l5.935 7.426.0-.86-6-7.504zm10.666 0v.94h4.17v-.94zm31.115.21v1.25h3.737V7.96zM25.83 9.99a5.47 5.47 0 0 0-4.41 2.246 6.29 6.29 0 0 0-1.28 3.903c.734-4.2 3.74-5.005 5.75-5.005 1.315 0 3.02.974 3.02.75v-.63h3.62V10.08l-3.494-.005v.503c0 .42-.426.245-.546.16-.905-.57-1.883-.726-2.66-.746zm7.96.09v1.174h3.51V10.08zm7.01 0v1.174h3.57V10.08zm20.867 0v1.17h3.746v-1.17zm-12.097.006v1.176h5.03v-1.176zm7.3.696v1.196h3.773v-1.196z"
    fill="#f3cf76"
  /><path
    d="m23.702 17.19c0 2.436 2.056 2.81 2.624 2.81s2.624-.375 2.624-2.81c-.37.91-1.334 1.743-2.624 1.75-1.51-.015-2.41-1.157-2.624-1.75zm25.855.206c.05 3.62 3.143 2.455 4.316 1.81l1.145 2.283.24-.15-1.514-3.37c-1.293.756-3.644.986-4.186-.57zm-12.074 1.188-.01.0a.41.41 0 0 0 .016.03zm.006.03c.125.645.49 1.45 1.584 1.45 1.11 0 1.46-.824 1.54-1.48 0 0-.095.17-.39.38-.35.245-.764.355-1.19.355s-.857-.104-1.19-.34c-.21-.144-.317-.303-.354-.365zm28.08.673v1.143h3.233v-1.143z"
    fill="#f3cb4b"
  /><path
    d="M70.429 6.668a.59.59 0 0 0-.6.6v.57a1.38 1.38 0 0 1 .7-.25l2.945-.002v-.32a.59.59 0 0 0-.6-.6zM80.83 9.785c-3.466 0-6.283 2.78-6.283 6.21 0-3.16 3.636-5.14 6.283-5.14s6.283 1.984 6.283 5.14c0-3.43-2.817-6.21-6.283-6.21zm14.25.08l-.233.011c-.975.043-1.91.48-2.67.963-.27.12-.4-.09-.4-.15v-.605l-3.69.0v1.04h3.813c0 .6-.014.62.04.713s.127.077.176.064c1.245-.846 2.35-.975 2.88-.975 1.567 0 3.35.84 4.173 2.61v-.567c-.181-1.83-2.473-3.115-4.087-3.106zm-25.26.825v1.29h3.72v-1.29z"
    fill="#ebb22f"
  /><path
    d="m78.29 16.96c0 2.435 2.12 2.73 2.54 2.73s2.54-.295 2.54-2.73h-.0c-.367.91-1.25 1.743-2.54 1.75-1.565 0-2.345-1.243-2.54-1.75zm-8.647 6c-.62.937-2.19 1.014-2.763.837l-1.03 3.376.104.045.737-2.434.28.04.46.04a3.42 3.42 0 0 0 .762-.04c.44-.077.75-.247.97-.48.375-.475.59-.94.48-1.383z"
    fill="#eb9900"
  /></svg
>
